export const LandingRoutes = {
  CONTACT_FORM: 'contactform/handleContactForm',
  VOUCHER_FORM: 'contactform/handleVoucherForm'
};
